import axios from 'axios';
import _ from 'lodash'

// initial state
// shape: [{ id, quantity }]
const state = () => ({
    logistics : {
      changed :0,
        cbm : [],
        fixeds: [],
        order_cbm : 0,
    },
    debounce: {
        updater: null,
    }
})

  // getters
  const getters = {
  }

  // actions
  const actions = {
  }

  // mutations
  const mutations = {
      clean(state){
        state.logistics = {
          changed: 0,
            cbm : [],
            fixeds: [],
            order_cbm : state.logistics.order_cbm,
        };
        state.logistics.changed++;
      },
      setTemp(state, object){
        Object.assign(state, object);
        state.logistics.changed++;
      },
      change(state, object){
        if(_.has(state, object.key)){
          _.set(state, object.key, object.value);
        }
      },
      push(state, object){
          var tmp = _.get(state, object.key);
          tmp.push(object.data);
          _.set(state, object.key, tmp);
          state.logistics.changed++;
      },
      splice(state, object){
        if(object && 'index' in object && 'key' in object){
            var tmp = _.get(state, object.key);
            if(tmp){
                tmp.splice(object.index, object.length);
                _.set(state, object.key, tmp);
            }
            state.logistics.changed++;
        }
      },
      async update(state, element){
            let index = state.logistics.fixeds.findIndex((item) => item.uniq == element.uniq);
            let useAmount = 0;
            if(parseFloat(element.data.transformedInvoiceAmount) > 0){
                useAmount = parseFloat(element.data.transformedInvoiceAmount);
            }else{
                useAmount = parseFloat(element.data.preCalculatedAmount);
            }

            if(index > -1){
                state.logistics.fixeds[index] = {
                    price : useAmount,
                    uniq: element.uniq,
                }
            }else{
                state.logistics.fixeds.push({
                    price : useAmount,
                    uniq: element.uniq,
                })
            }
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
